import "@/App.css";
import Brochure from "@/components/Brochure";

function App() {
  return (
    <div className="App">
      <Brochure />
    </div>
  );
}

export default App;
